"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendUserEvents = exports.WITH_SELFIE = exports.WITHOUT_SELFIE = exports.USER_ACTION_DIAGNOSIS_STARTED = exports.USER_ACTION_DIAGNOSIS_COMPLETED = exports.TRACKING_TITLE_SELFIE = exports.TRACKING_TITLE_CONDITIONS = exports.TRACKING_CATEGORY_PRODUCT_RECOMMENDATION = void 0;
var UserAction = _interopRequireWildcard(require("@ori-events/user-action"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const TRACKING_TITLE_CONDITIONS = exports.TRACKING_TITLE_CONDITIONS = 'Conditions';
const TRACKING_TITLE_SELFIE = exports.TRACKING_TITLE_SELFIE = 'Selfie';
const TRACKING_CATEGORY_PRODUCT_RECOMMENDATION = exports.TRACKING_CATEGORY_PRODUCT_RECOMMENDATION = 'Product Recommendation';
const USER_ACTION_DIAGNOSIS_STARTED = exports.USER_ACTION_DIAGNOSIS_STARTED = ['skin_advisor', 'Skin diagnosis started'];
const USER_ACTION_DIAGNOSIS_COMPLETED = exports.USER_ACTION_DIAGNOSIS_COMPLETED = ['skin_advisor', 'Skin diagnosis completed'];
const WITH_SELFIE = exports.WITH_SELFIE = 'With selfie';
const WITHOUT_SELFIE = exports.WITHOUT_SELFIE = 'Without selfie';
const sendUserEvents = ({
  payload
}) => {
  if (payload.payload) {
    const {
      category,
      items
    } = payload.payload;
    if (category === TRACKING_CATEGORY_PRODUCT_RECOMMENDATION && items) {
      UserAction.dispatch([...USER_ACTION_DIAGNOSIS_COMPLETED, items.map(p => p.item_id).join(',')]);
    }
  }
  switch (payload.title) {
    case TRACKING_TITLE_CONDITIONS:
      UserAction.dispatch([...USER_ACTION_DIAGNOSIS_STARTED, WITHOUT_SELFIE]);
      break;
    case TRACKING_TITLE_SELFIE:
      UserAction.dispatch([...USER_ACTION_DIAGNOSIS_STARTED, WITH_SELFIE]);
      break;
    default:
      break;
  }
};
exports.sendUserEvents = sendUserEvents;
